/* Jhilke wishlist, cart event bridge (LO, 15 Oct 2026).
   A module on purpose: Shopify minifies classic theme assets and rewrites a dynamic import() into require(),
   which does not exist in the browser (found on the QA theme, 15 Oct). This module imports the theme's event
   library statically (the import map in snippets/scripts.liquid) and exposes one function that the classic
   assets/jhilke-wishlist.js calls after a successful cart/add.js. Loaded only by snippets/jh-wishlist-list.liquid. */
import { CartLinesUpdateEvent } from '@shopify/events';

window.jhCartLinesUpdate = function (cart, lines, sections) {
  var deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: lines,
    promise: deferred.promise
  }));
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: { items: cart.items, source: 'jhilke-wishlist', itemCount: lines.length, sections: sections || {}, didError: false }
  });
};
